module.exports = __webpack_public_path__ + "img/whatsApp-qr.1a2dbc09.png";